/* Synouvelle Footer-Newsletter (22.10.2026, Mario): Anmeldung direkt an Klaviyo.
   Die Liste hat Double-Opt-in, Klaviyo schickt die eine Bestätigungsmail; nach dem Klick
   startet der Willkommens-Flow. Ohne JavaScript läuft das Formular wie bisher über Shopify.
   Alle Texte kommen aus den Einstellungen der Footer-Sektion. */
(function () {
  var box = document.querySelector('.footer-block__newsletter[data-syn-kl-liste]');
  if (!box) return;
  var form = box.querySelector('form');
  var input = form && form.querySelector('input[type="email"]');
  var status = box.querySelector('.syn-nl-status');
  var button = form && form.querySelector('button[type="submit"]');
  if (!form || !input || !status) return;

  function zeige(text, fehler) {
    status.textContent = text;
    status.hidden = false;
    status.classList.toggle('syn-nl-status--fehler', !!fehler);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = input.value.trim();
    if (!email || !input.checkValidity()) {
      input.reportValidity();
      return;
    }
    if (button) button.disabled = true;
    var sprache = (box.dataset.synSprache || 'de').toLowerCase();
    var attribute = {
      profile: {
        data: {
          type: 'profile',
          attributes: { email: email, properties: { Sprache: sprache } }
        }
      }
    };
    if (box.dataset.synKlQuelle) attribute.custom_source = box.dataset.synKlQuelle;
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(box.dataset.synKlKonto), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: attribute,
          relationships: { list: { data: { type: 'list', id: box.dataset.synKlListe } } }
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        box.classList.add('syn-nl--fertig');
        zeige(box.dataset.synOk, false);
        status.focus && status.setAttribute('tabindex', '-1');
        status.focus && status.focus();
      })
      .catch(function () {
        zeige(box.dataset.synFehler, true);
        if (button) button.disabled = false;
      });
  });
})();
